import { useEffect } from 'react';
import './Contact.css';

export default function Contact() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="wrapper contact-page">
      <div className="container">
        <div className="page-hero reveal">
          <p className="sec-label">Get In Touch</p>
          <h1 className="sec-h2 page-h1">Contact Last Maisiri</h1>
          <p className="sec-sub">Have a question or want to place an order? Reach out directly — WhatsApp is fastest!</p>
        </div>

        <div className="contact-layout">
          {/* CONTACT CARDS */}
          <div className="contact-cards reveal">
            <a href="https://wa.me/263713508064" target="_blank" rel="noreferrer" className="contact-card contact-card-wa">
              <span className="contact-card-icon">📱</span>
              <div className="contact-card-label">WhatsApp (Fastest)</div>
              <div className="contact-card-value">+263 713 508 064</div>
              <div className="contact-card-sub">Usually replies within minutes</div>
            </a>
            <a href="tel:+263713508064" className="contact-card">
              <span className="contact-card-icon">📞</span>
              <div className="contact-card-label">Phone Call</div>
              <div className="contact-card-value">+263 713 508 064</div>
              <div className="contact-card-sub">Available 8am – 9pm daily</div>
            </a>
            <div className="contact-card">
              <span className="contact-card-icon">📍</span>
              <div className="contact-card-label">Location</div>
              <div className="contact-card-value">Bindura, Zimbabwe</div>
              <div className="contact-card-sub">Mashonaland Central Province</div>
            </div>
            <div className="contact-card">
              <span className="contact-card-icon">⏰</span>
              <div className="contact-card-label">Hours</div>
              <div className="contact-card-value">8am – 9pm</div>
              <div className="contact-card-sub">Monday to Sunday</div>
            </div>
          </div>

          {/* FORM */}
          <div className="contact-form-wrap reveal">
            <h2 className="contact-form-title">Send a Message</h2>
            <p className="contact-form-sub">Fill this form and Last will respond via WhatsApp</p>
            <form className="contact-form" onSubmit={e => { e.preventDefault(); window.open(`https://wa.me/263713508064?text=Hi%20Last!%20I%20sent%20a%20message%20from%20your%20website.`, '_blank'); }}>
              <div className="form-row">
                <div className="form-group">
                  <label>Your Name</label>
                  <input type="text" placeholder="John Doe" required />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input type="tel" placeholder="+263 7XX XXX XXX" required />
                </div>
              </div>
              <div className="form-group">
                <label>Subject</label>
                <input type="text" placeholder="I want to order an iPhone 15..." required />
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea rows={5} placeholder="Tell Last what you need..." required />
              </div>
              <button type="submit" className="btn btn-wa" style={{width:'100%',justifyContent:'center'}}>
                📱 Send via WhatsApp
              </button>
            </form>
          </div>
        </div>

        {/* OWNER CARD */}
        <div className="owner-card reveal">
          <div className="owner-avatar">LM</div>
          <div className="owner-info">
            <div className="owner-name">Last Maisiri</div>
            <div className="owner-title">Founder & Owner — LastTech Zimbabwe</div>
            <p className="owner-bio">Passionate tech enthusiast bringing the best gadgets to Zimbabwe at unbeatable prices. Personal service, genuine products, and fast delivery from Bindura to your doorstep.</p>
            <div className="owner-actions">
              <a href="https://wa.me/263713508064" target="_blank" rel="noreferrer" className="btn btn-wa btn-sm">📱 WhatsApp Last</a>
              <a href="tel:+263713508064" className="btn btn-outline btn-sm">📞 Call Now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
